var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { t, Translate } from "../../I18N";
import { Icon } from "../../UI";
import { Warning } from "../../Layout";
import { closePanel, deactivateReference } from "../actions/uiActions";
import Connection from "./Connection";
import { sortTextSelections } from "../utils/sortTextSelections";

import "../scss/viewReferencesPanel.scss";

export class ConnectionsList extends Component {
  static blankStateMessage(title, message) {
    return /*#__PURE__*/(
      _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "sitemap" }), /*#__PURE__*/
      _jsx("h4", {}, void 0, t('System', title)), /*#__PURE__*/
      _jsx("p", {}, void 0, t('System', message))
      ));

  }

  // TODO: remove this method is it's not used anywhere
  // eslint-disable-next-line react/no-unused-class-component-methods
  close() {
    this.props.closePanel();
    this.props.deactivateReference();
  }

  render() {
    const references = this.props.references.
    toJS().
    sort((a, b) => sortTextSelections(a.reference, b.reference));

    if (this.props.loading) {
      return false;
    }

    if (!this.props.references.size && this.props.referencesSection === 'references') {
      return ConnectionsList.blankStateMessage('No References', 'No References description');
    }

    if (!this.props.references.size) {
      return ConnectionsList.blankStateMessage('No Connections', 'No Connections description');
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "item-group" }, void 0,
      references.length > 299 && /*#__PURE__*/
      _jsx(Warning, { inline: true }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Text references limit warning" }, void 0, "Text references are temporarily limited to a maximum of 300. We are currently working on a fix for this issue."


      )
      ),

      (() =>
      references.map((reference) => /*#__PURE__*/
      _jsx(Connection, { readOnly: this.props.readOnly, reference: reference }, reference._id)
      ))()
      ));

  }
}










function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closePanel, deactivateReference }, dispatch);
}

export default connect(null, mapDispatchToProps)(ConnectionsList);